<script context="module" lang="ts">
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';
  import ProductTilePriceNewDiscountGroup from './ProductTilePriceNewDiscountGroup.svelte';
  import ProductTilePriceNewWalletGroup from './ProductTilePriceNewWalletGroup.svelte';

  const benefitType = window.ACC.config.benefitType || 'DISCOUNT';
  const productTilePriceNewGroupComponent =
    benefitType === 'DISCOUNT' ? ProductTilePriceNewDiscountGroup : ProductTilePriceNewWalletGroup;
</script>

<script lang="ts">
  export let product;
  export let pdpGiftCardPriceData = null;
  export let variant: ProductTilePriceGroupVariantType = 'plp-list';
  export let isMegasaleProduct = [];
</script>

<svelte:component
  this={productTilePriceNewGroupComponent}
  {product}
  {pdpGiftCardPriceData}
  {variant}
  {isMegasaleProduct}
/>
